module.exports = __webpack_public_path__ + "static/travel-2ead111e3c65555a72e7b012b1bfc05f.png";